window.cf = window.cf || {};
(function ($) {
    /* Application paths *****************************************/

    // Current application root path (including virtual directory if exists).
    cf.appPath = cf.appPath || '/';

    cf.pageLoadTime = new Date();

    // Converts given path to absolute path using cf.appPath variable.
    cf.toAbsAppPath = function (path) {
        if (path.indexOf('/') === 0) {
            path = path.substring(1);
        }

        return cf.appPath + path;
    };

    /* MULTITENANCY */

    cf.multiTenancy = cf.multiTenancy || {};

    cf.multiTenancy.isEnabled = false;

    cf.multiTenancy.sides = {
        TENANT: 1,
        HOST: 2
    };

    cf.multiTenancy.tenantIdCookieName = 'Abp.TenantId';

    cf.multiTenancy.setTenantIdCookie = function (tenantId) {
        if (tenantId) {
            cf.utils.setCookieValue(
                cf.multiTenancy.tenantIdCookieName,
                tenantId.toString(),
                new Date(new Date().getTime() + 5 * 365 * 86400000), // 5 years
                cf.appPath
            );
        } else {
            cf.utils.deleteCookie(cf.multiTenancy.tenantIdCookieName, cf.appPath);
        }
    };

    cf.multiTenancy.getTenantIdCookie = function () {
        var value = cf.utils.getCookieValue(cf.multiTenancy.tenantIdCookieName);
        if (!value) {
            return null;
        }

        return parseInt(value);
    };

    /* SESSION */

    cf.session = cf.session || {
        multiTenancySide: cf.multiTenancy.sides.HOST
    };

    /* LOCALIZATION ***********************************************/
    // Implements Localization API that simplifies usage of localization scripts generated by cf.

    cf.localization = cf.localization || {};

    cf.localization.languages = [];

    cf.localization.currentLanguage = {};

    cf.localization.sources = [];

    cf.localization.values = {};

    cf.localization.localize = function (key, sourceName) {
        sourceName = sourceName || cf.localization.defaultSourceName;

        var source = cf.localization.values[sourceName];

        if (!source) {
            cf.log.warn('Could not find localization source: ' + sourceName + ' key: ' + key);
            return key;
        }

        var value = source[key];
        if (value === undefined) {
            return key;
        }

        var copiedArguments = Array.prototype.slice.call(arguments, 0);
        copiedArguments.splice(1, 1);
        copiedArguments[0] = value;

        return cf.utils.formatString.apply(this, copiedArguments);
    };

    cf.localization.getSource = function (sourceName) {
        return function (key) {
            var copiedArguments = Array.prototype.slice.call(arguments, 0);
            copiedArguments.splice(1, 0, sourceName);
            return cf.localization.localize.apply(this, copiedArguments);
        };
    };

    cf.localization.isCurrentCulture = function (name) {
        return cf.localization.currentCulture &&
            cf.localization.currentCulture.name &&
            cf.localization.currentCulture.name.indexOf(name) === 0;
    };

    cf.localization.defaultSourceName = undefined;
    cf.localization.middleware = cf.localization.getSource('Middleware');

    /* AUTHORIZATION **********************************************/
    // Implements Authorization API that simplifies usage of authorization scripts generated by cf.

    cf.auth = cf.auth || {};

    cf.auth.allPermissions = cf.auth.allPermissions || {};

    cf.auth.grantedPermissions = cf.auth.grantedPermissions || {};

    // Deprecated. Use cf.auth.isGranted instead.
    cf.auth.hasPermission = function (permissionName) {
        return cf.auth.isGranted.apply(this, arguments);
    };

    // Deprecated. Use cf.auth.isAnyGranted instead.
    cf.auth.hasAnyOfPermissions = function () {
        return cf.auth.isAnyGranted.apply(this, arguments);
    };

    // Deprecated. Use cf.auth.areAllGranted instead.
    cf.auth.hasAllOfPermissions = function () {
        return cf.auth.areAllGranted.apply(this, arguments);
    };

    cf.auth.isGranted = function (permissionName) {
        return cf.auth.allPermissions[permissionName] !== undefined && cf.auth.grantedPermissions[permissionName] !== undefined;
    };

    cf.auth.isAnyGranted = function () {
        if (!arguments || arguments.length <= 0) {
            return true;
        }

        for (var i = 0; i < arguments.length; i++) {
            if (cf.auth.isGranted(arguments[i])) {
                return true;
            }
        }

        return false;
    };

    cf.auth.areAllGranted = function () {
        if (!arguments || arguments.length <= 0) {
            return true;
        }

        for (var i = 0; i < arguments.length; i++) {
            if (!cf.auth.isGranted(arguments[i])) {
                return false;
            }
        }

        return true;
    };

    cf.auth.tokenCookieName = 'CF.AuthToken';
    cf.nav = [];
    cf.auth.setToken = function (authToken, expireDate) {
        cf.utils.setCookieValue(cf.auth.tokenCookieName, authToken, expireDate, cf.appPath);
    };

    cf.auth.getToken = function () {
        return cf.utils.getCookieValue(cf.auth.tokenCookieName);
    };

    cf.auth.clearToken = function () {
        cf.auth.setToken();
    };

    /* FEATURE SYSTEM *********************************************/
    // Implements Features API that simplifies usage of feature scripts generated by cf.

    cf.features = cf.features || {};

    cf.features.allFeatures = cf.features.allFeatures || {};

    cf.features.get = function (name) {
        return cf.features.allFeatures[name];
    };

    cf.features.getValue = function (name) {
        var feature = cf.features.get(name);
        if (feature === undefined) {
            return undefined;
        }

        return feature.value;
    };

    cf.features.isEnabled = function (name) {
        var value = cf.features.getValue(name);
        return value === 'true' || value === 'True';
    };

    /* SETTINGS **************************************************/
    // Implements Settings API that simplifies usage of setting scripts generated by cf.

    cf.setting = cf.setting || {};

    cf.setting.values = cf.setting.values || {};

    cf.setting.get = function (name) {
        return cf.setting.values[name];
    };

    cf.setting.getBoolean = function (name) {
        var value = cf.setting.get(name);
        return value === 'true' || value === 'True';
    };

    cf.setting.getInt = function (name) {
        return parseInt(cf.setting.values[name]);
    };

    /* REALTIME NOTIFICATIONS ************************************/

    cf.notifications = cf.notifications || {};

    cf.notifications.severity = {
        INFO: 0,
        SUCCESS: 1,
        WARN: 2,
        ERROR: 3,
        FATAL: 4
    };

    cf.notifications.userNotificationState = {
        UNREAD: 0,
        READ: 1
    };

    cf.notifications.getUserNotificationStateAsString = function (userNotificationState) {
        switch (userNotificationState) {
            case cf.notifications.userNotificationState.READ:
                return 'READ';
            case cf.notifications.userNotificationState.UNREAD:
                return 'UNREAD';
            default:
                cf.log.warn('Unknown user notification state value: ' + userNotificationState);
                return '?';
        }
    };

    cf.notifications.getUiNotifyFuncBySeverity = function (severity) {
        switch (severity) {
            case cf.notifications.severity.SUCCESS:
                return cf.notify.success;
            case cf.notifications.severity.WARN:
                return cf.notify.warn;
            case cf.notifications.severity.ERROR:
                return cf.notify.error;
            case cf.notifications.severity.FATAL:
                return cf.notify.error;
            case cf.notifications.severity.INFO:
            default:
                return cf.notify.info;
        }
    };

    cf.notifications.messageFormatters = {};

    cf.notifications.messageFormatters['Abp.Notifications.MessageNotificationData'] = function (userNotification) {
        return userNotification.notification.data.message || userNotification.notification.data.properties.Message;
    };

    cf.notifications.messageFormatters['Abp.Notifications.LocalizableMessageNotificationData'] = function (userNotification) {
        var message = userNotification.notification.data.message || userNotification.notification.data.properties.Message;
        var localizedMessage = cf.localization.localize(
            message.name,
            message.sourceName
        );

        if (userNotification.notification.data.properties) {
            if ($) {
                // Prefer to use jQuery if possible
                $.each(userNotification.notification.data.properties, function (key, value) {
                    localizedMessage = localizedMessage.replace('{' + key + '}', value);
                });
            } else {
                // alternative for $.each
                var properties = Object.keys(userNotification.notification.data.properties);
                for (var i = 0; i < properties.length; i++) {
                    localizedMessage = localizedMessage.replace('{' + properties[i] + '}', userNotification.notification.data.properties[properties[i]]);
                }
            }
        }

        return localizedMessage;
    };

    cf.notifications.getFormattedMessageFromUserNotification = function (userNotification) {
    


            var formatter = cf.notifications.messageFormatters[userNotification.notification.data.type];
            
            if (!formatter) {
                cf.log.warn('No message formatter defined for given data type: ' + userNotification.notification.data.type);
                return '?';
            }
            
            if (!cf.utils.isFunction(formatter)) {
                cf.log.warn('Message formatter should be a function! It is invalid for data type: ' + userNotification.notification.data.type);
                return '?';
            }
            
            return formatter(userNotification);

  };

  cf.notifications.showUiNotifyForUserNotification = function (userNotification, options) {
    //var message = cf.notifications.getFormattedMessageFromUserNotification(userNotification);
    // console.log(userNotification.notification.data.properties);
    // var uiNotifyFunc = cf.notifications.getUiNotifyFuncBySeverity(userNotification.notification.severity);
    // console.log(uiNotifyFunc);
    // let prop=userNotification.notification.data.properties;
    // uiNotifyFunc(prop[0].key,prop[0].value, options);
  };

  /* LOGGING ***************************************************/
  // Implements Logging API that provides secure & controlled usage of console.log

  cf.log = cf.log || {};

  cf.log.levels = {
    DEBUG: 1,
    INFO: 2,
    WARN: 3,
    ERROR: 4,
    FATAL: 5
  };

  cf.log.level = cf.log.levels.DEBUG;

  cf.log.log = function (logObject, logLevel) {
    if (!window.console || !window.console.log) {
      return;
    }

    if (logLevel !== undefined && logLevel < cf.log.level) {
      return;
    }
  };

  cf.log.debug = function (logObject) {
    cf.log.log('DEBUG: ', cf.log.levels.DEBUG);
    cf.log.log(logObject, cf.log.levels.DEBUG);
  };

  cf.log.info = function (logObject) {
    cf.log.log('INFO: ', cf.log.levels.INFO);
    cf.log.log(logObject, cf.log.levels.INFO);
  };

  cf.log.warn = function (logObject) {
    cf.log.log('WARN: ', cf.log.levels.WARN);
    cf.log.log(logObject, cf.log.levels.WARN);
  };

  cf.log.error = function (logObject) {
    cf.log.log('ERROR: ', cf.log.levels.ERROR);
    cf.log.log(logObject, cf.log.levels.ERROR);
  };

  cf.log.fatal = function (logObject) {
    cf.log.log('FATAL: ', cf.log.levels.FATAL);
    cf.log.log(logObject, cf.log.levels.FATAL);
  };

  /* NOTIFICATION *********************************************/
  // Defines Notification API, not implements it

  cf.notify = cf.notify || {};

  cf.notify.success = function (message, title, options) {
    cf.log.warn('cf.notify.success is not implemented!');
  };

  cf.notify.info = function (message, title, options) {
    cf.log.warn('cf.notify.info is not implemented!');
  };

  cf.notify.warn = function (message, title, options) {
    cf.log.warn('cf.notify.warn is not implemented!');
  };

  cf.notify.error = function (message, title, options) {
    cf.log.warn('cf.notify.error is not implemented!');
  };

  /* MESSAGE **************************************************/
  // Defines Message API, not implements it

  cf.message = cf.message || {};

  var showMessage = function (message, title) {
    alert((title || '') + ' ' + message);

    if (!$) {
      cf.log.warn('cf.message can not return promise since jQuery is not defined!');
      return null;
    }

    return $.Deferred(function ($dfd) {
      $dfd.resolve();
    });
  };

  cf.message.info = function (message, title) {
    cf.log.warn('cf.message.info is not implemented!');
    return showMessage(message, title);
  };

  cf.message.success = function (message, title) {
    cf.log.warn('cf.message.success is not implemented!');
    return showMessage(message, title);
  };

  cf.message.warn = function (message, title) {
    cf.log.warn('cf.message.warn is not implemented!');
    return showMessage(message, title);
  };

  cf.message.error = function (message, title) {
    cf.log.warn('cf.message.error is not implemented!');
    return showMessage(message, title);
  };

  cf.message.confirm = function (message, titleOrCallback, callback) {
    cf.log.warn('cf.message.confirm is not implemented!');

    if (titleOrCallback && !(typeof titleOrCallback === 'string')) {
      callback = titleOrCallback;
    }

    var result = confirm(message);
    callback && callback(result);

    if (!$) {
      cf.log.warn('cf.message can not return promise since jQuery is not defined!');
      return null;
    }

    return $.Deferred(function ($dfd) {
      $dfd.resolve();
    });
  };

  /* UI *******************************************************/

  cf.ui = cf.ui || {};

  /* UI BLOCK */
  // Defines UI Block API, not implements it

  cf.ui.block = function (elm) {
    cf.log.warn('cf.ui.block is not implemented!');
  };

  cf.ui.unblock = function (elm) {
    cf.log.warn('cf.ui.unblock is not implemented!');
  };

  /* UI BUSY */
  // Defines UI Busy API, not implements it

  cf.ui.setBusy = function (elm, optionsOrPromise) {
    cf.log.warn('cf.ui.setBusy is not implemented!');
  };

  cf.ui.clearBusy = function (elm) {
    cf.log.warn('cf.ui.clearBusy is not implemented!');
  };

  /* 简单事件总线 *****************************************/

  cf.event = (function () {
    var _callbacks = {};

    var on = function (eventName, callback) {
      if (!_callbacks[eventName]) {
        _callbacks[eventName] = [];
      }

      _callbacks[eventName].push(callback);
    };

    var off = function (eventName, callback) {
      var callbacks = _callbacks[eventName];
      if (!callbacks) {
        return;
      }

      var index = -1;
      for (var i = 0; i < callbacks.length; i++) {
        if (callbacks[i] === callback) {
          index = i;
          break;
        }
      }

      if (index < 0) {
        return;
      }

      _callbacks[eventName].splice(index, 1);
    };

    var trigger = function (eventName) {
      var callbacks = _callbacks[eventName];
      if (!callbacks || !callbacks.length) {
        return;
      }

      var args = Array.prototype.slice.call(arguments, 1);
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].apply(this, args);
      }
    };

    // Public interface ///////////////////////////////////////////////////

    return {
      on: on,
      off: off,
      trigger: trigger
    };
  })();

  /* UTILS ***************************************************/

  cf.utils = cf.utils || {};

  /* Creates a name namespace.
   *  Example:
   *  var taskService = cf.utils.createNamespace(cf, 'services.task');
   *  taskService will be equal to cf.services.task
   *  first argument (root) must be defined first
   ************************************************************/
  cf.utils.createNamespace = function (root, ns) {
    var parts = ns.split('.');
    for (var i = 0; i < parts.length; i++) {
      if (typeof root[parts[i]] === 'undefined') {
        root[parts[i]] = {};
      }

      root = root[parts[i]];
    }

    return root;
  };

  /* Find and replaces a string (search) to another string (replacement) in
   *  given string (str).
   *  Example:
   *  cf.utils.replaceAll('This is a test string', 'is', 'X') = 'ThX X a test string'
   ************************************************************/
  cf.utils.replaceAll = function (str, search, replacement) {
    var fix = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return str.replace(new RegExp(fix, 'g'), replacement);
  };

  /* Formats a string just like string.format in C#.
   *  Example:
   *  cf.utils.formatString('Hello {0}','Tuana') = 'Hello Tuana'
   ************************************************************/
  cf.utils.formatString = function () {
    if (arguments.length < 1) {
      return null;
    }

    var str = arguments[0];

    for (var i = 1; i < arguments.length; i++) {
      var placeHolder = '{' + (i - 1) + '}';
      str = cf.utils.replaceAll(str, placeHolder, arguments[i]);
    }

    return str;
  };

  cf.utils.toPascalCase = function (str) {
    if (!str || !str.length) {
      return str;
    }

    if (str.length === 1) {
      return str.charAt(0).toUpperCase();
    }

    return str.charAt(0).toUpperCase() + str.substr(1);
  };

  cf.utils.toCamelCase = function (str) {
    if (!str || !str.length) {
      return str;
    }

    if (str.length === 1) {
      return str.charAt(0).toLowerCase();
    }

    return str.charAt(0).toLowerCase() + str.substr(1);
  };

  cf.utils.truncateString = function (str, maxLength) {
    if (!str || !str.length || str.length <= maxLength) {
      return str;
    }

    return str.substr(0, maxLength);
  };

  cf.utils.truncateStringWithPostfix = function (str, maxLength, postfix) {
    postfix = postfix || '...';

    if (!str || !str.length || str.length <= maxLength) {
      return str;
    }

    if (maxLength <= postfix.length) {
      return postfix.substr(0, maxLength);
    }

    return str.substr(0, maxLength - postfix.length) + postfix;
  };

  cf.utils.isFunction = function (obj) {
    if ($) {
      return $.isFunction(obj);
    }

    return !!(obj && obj.constructor && obj.call && obj.apply);
  };

  cf.utils.buildQueryString = function (parameterInfos, includeQuestionMark) {
    if (includeQuestionMark === undefined) {
      includeQuestionMark = true;
    }

    var qs = '';

    function addSeperator() {
      if (!qs.length) {
        if (includeQuestionMark) {
          qs = qs + '?';
        }
      } else {
        qs = qs + '&';
      }
    }

    for (var i = 0; i < parameterInfos.length; ++i) {
      var parameterInfo = parameterInfos[i];
      if (parameterInfo.value === undefined) {
        continue;
      }

      if (parameterInfo.value === null) {
        parameterInfo.value = '';
      }

      addSeperator();

      if (parameterInfo.value.toJSON && typeof parameterInfo.value.toJSON === 'function') {
        qs = qs + parameterInfo.name + '=' + encodeURIComponent(parameterInfo.value.toJSON());
      } else if (Array.isArray(parameterInfo.value) && parameterInfo.value.length) {
        for (var j = 0; j < parameterInfo.value.length; j++) {
          if (j > 0) {
            addSeperator();
          }

          qs = qs + parameterInfo.name + '[' + j + ']=' + encodeURIComponent(parameterInfo.value[j]);
        }
      } else {
        qs = qs + parameterInfo.name + '=' + encodeURIComponent(parameterInfo.value);
      }
    }

    return qs;
  };

  cf.utils.setCookieValue = function (key, value, expireDate, path) {
    var cookieValue = encodeURIComponent(key) + '=';

    if (value) {
      cookieValue = cookieValue + encodeURIComponent(value);
    }

    if (expireDate) {
      cookieValue = cookieValue + '; expires=' + expireDate.toUTCString();
    }

    if (path) {
      cookieValue = cookieValue + '; path=' + path;
    }

    document.cookie = cookieValue;
  };

  cf.utils.getCookieValue = function (key) {
    var equalities = document.cookie.split('; ');
    for (var i = 0; i < equalities.length; i++) {
      if (!equalities[i]) {
        continue;
      }

      var splitted = equalities[i].split('=');
      if (splitted.length !== 2) {
        continue;
      }

      if (decodeURIComponent(splitted[0]) === key) {
        return decodeURIComponent(splitted[1] || '');
      }
    }

    return null;
  };

  cf.utils.deleteCookie = function (key, path) {
    var cookieValue = encodeURIComponent(key) + '=';

    cookieValue = cookieValue + '; expires=' + (new Date(new Date().getTime() - 86400000)).toUTCString();

    if (path) {
      cookieValue = cookieValue + '; path=' + path;
    }

    document.cookie = cookieValue;
  };

  /* 时间 *****************************************/
  cf.timing = cf.timing || {};

  cf.timing.utcClockProvider = (function () {
    var toUtc = function (date) {
      return Date.UTC(
        date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds()
      );
    };

    var now = function () {
      return new Date();
    };

    var normalize = function (date) {
      if (!date) {
        return date;
      }

      return new Date(toUtc(date));
    };

    // 公开接口 ///////////////////////////////////////////////////

    return {
      now: now,
      normalize: normalize,
      supportsMultipleTimezone: true
    };
  })();

  cf.timing.localClockProvider = (function () {
    var toLocal = function (date) {
      return new Date(
        date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()
      );
    };

    var now = function () {
      return toLocal(new Date());
    };

    var normalize = function (date) {
      if (!date) {
        return date;
      }

      return toLocal(date);
    };

    // 公开接口 ///////////////////////////////////////////////////

    return {
      now: now,
      normalize: normalize,
      supportsMultipleTimezone: false
    };
  })();

  cf.timing.unspecifiedClockProvider = (function () {
    var now = function () {
      return new Date();
    };

    var normalize = function (date) {
      return date;
    };

    // 公开接口 ///////////////////////////////////////////////////

    return {
      now: now,
      normalize: normalize,
      supportsMultipleTimezone: false
    };
  })();

  cf.timing.convertToUserTimezone = function (date) {
    var localTime = date.getTime();
    var utcTime = localTime + (date.getTimezoneOffset() * 60000);
    var targetTime = parseInt(utcTime) + parseInt(cf.timing.timeZoneInfo.windows.currentUtcOffsetInMilliseconds);
    return new Date(targetTime);
  };

  /* 时钟 *****************************************/
  cf.clock = cf.clock || {};

  cf.clock.now = function () {
    if (cf.clock.provider) {
      return cf.clock.provider.now();
    }

    return new Date();
  };

  cf.clock.normalize = function (date) {
    if (cf.clock.provider) {
      return cf.clock.provider.normalize(date);
    }

    return date;
  };

  cf.clock.provider = cf.timing.unspecifiedClockProvider;

  /* 安全 ***************************************/
  cf.security = cf.security || {};
  cf.security.antiForgery = cf.security.antiForgery || {};

  cf.security.antiForgery.tokenCookieName = 'XSRF-TOKEN';
  cf.security.antiForgery.tokenHeaderName = 'X-XSRF-TOKEN';

  cf.security.antiForgery.getToken = function () {
    return cf.utils.getCookieValue(cf.security.antiForgery.tokenCookieName);
  };
})(jQuery);
